// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__2tOLg","form":"styles_form__2dAYo"};